import './header.style.css';
import { Layout, Avatar, Flex, Dropdown, Image } from 'antd';
import { Logout01Icon, Menu01Icon, UserCircleIcon, UserSwitchIcon } from 'hugeicons-react';
import { useHeader } from './logic/useHeader.logic';
import { useTheme } from '../../theme';
import { View } from '../Element';
import AccountSwitcher from '../../container/screen/Users/subcomponents/AccountSwitcher';
import headerStyle from './header.style';
import useDeviceSize from '../../hooks/useDeviceSize';

export const Header = ({ toggleSider, isActive }: { toggleSider: Function; isActive?: boolean }) => {
  const { doSignOut, doToggleAccountSwitcher, user, doGoLandingUrl } = useHeader();
  const deviceSize = useDeviceSize();
  const style = headerStyle(useTheme(), deviceSize, isActive);

  return (
    <>
      <AccountSwitcher />
      <Layout.Header style={style.container}>
        <Flex vertical={false} align="center" justify={'space-between'} gap={24} style={style.flexer}>
          {!deviceSize.isDesktop ? <Menu01Icon style={style.iconButton} onClick={() => toggleSider((p: boolean) => !p)} /> : null}
          <View style={style.logoWrapper} onClick={() => doGoLandingUrl()}>
            <Image src="/assets/logo.png" style={style.logo} preview={false} />
          </View>
          <Flex vertical={false} align="center" justify="end" gap={0}>
            <Dropdown
              placement="bottomLeft"
              menu={{
                items: [
                  {
                    label: 'Switch Account',
                    icon: <UserSwitchIcon size={18} />,
                    extra: '',
                    key: 'userSwitch',
                    onClick: () => doToggleAccountSwitcher(true),
                  },
                  {
                    label: 'Sign Out',
                    icon: <Logout01Icon size={18} />,
                    key: 'doSignOut',
                    onClick: () => doSignOut(),
                  },
                ],
              }}
            >
              {user?.profilePicture ? (
                <Avatar src={user?.profilePicture} style={style.iconButton} />
              ) : (
                <UserCircleIcon style={style.iconButton} />
              )}
            </Dropdown>
          </Flex>
        </Flex>
      </Layout.Header>
    </>
  );
};

export default Header;
